import { useRuntimeConfig } from '#imports'
import * as Sentry from '@sentry/nuxt'
import { useRouter } from 'vue-router'

const config = useRuntimeConfig()

Sentry.init({
  dsn: config.public.SENTRY_DSN,
  environment: config.public.SENTRY_ENV === 'int' ? 'int' : 'prod',
  release: config.public.RELEASE_VERSION as string,
  sampleRate: 0.3,
  tracesSampleRate: 0.3,
  integrations: [
    Sentry.browserTracingIntegration({
      router: useRouter(),
      enableHTTPTimings: true,
      instrumentPageLoad: true,
      instrumentNavigation: true,
    }),
  ],
})